module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_3.ede5e765.png";